import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {DripSequenceSortType, CampaignStatus} from 'nutshell-graphql-types';
import type {
    GetDripSequences as GetDripSequencesQuery,
    GetDripSequencesVariables as GetDripSequencesQueryVariables,
    DripSequenceStubFragment as DripSequence,
} from 'nutshell-graphql-types';

import {getDripSequenceListQueryVariables} from '../helpers';

import GET_DRIP_SEQUENCES from './graphql/queries/get-drip-sequences.graphql';

type Props = {
    isArchived: boolean;
    sortOrder: DripSequenceSortType;
    searchQuery?: string;
    creatorUserId?: string;
    lastUpdatedTime?: string | null | undefined;
    statuses?: CampaignStatus[];
    children: (arg1: {
        dripSequences: DripSequence[];
        isLoading: boolean;
        error: string | null | undefined;
    }) => React.ReactElement;
};

export function DripSequenceListQuery(props: Props) {
    const variables = getDripSequenceListQueryVariables(
        props.isArchived,
        props.sortOrder,
        props.searchQuery,
        props.creatorUserId,
        props.lastUpdatedTime,
        props.statuses
    );

    const {
        data,
        error,
        loading: isLoading,
    } = useQuery<GetDripSequencesQuery, GetDripSequencesQueryVariables>(GET_DRIP_SEQUENCES, {
        variables: variables,
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    const dripSequencesData = data ? data.dripSequences : null;

    const dripSequences = dripSequencesData
        ? dripSequencesData.edges.map((audience) => {
              return audience.node;
          })
        : [];

    return props.children({
        dripSequences,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    });
}
